"use strict";
/**
 * 模块依赖检测和初始化相关
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.beforeInit = void 0;
/**
 * 通用前置检测
 * 检测前置依赖的模块数组是否存在
 */
exports.beforeInit = function (UIP) { return function () {
    var modules = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        modules[_i] = arguments[_i];
    }
    if (!UIP || typeof UIP !== 'object' || modules.some(function (v) { return !UIP[v]; })) {
        console.error("This module must be pre dependent on UIP and \n            " + modules.join(',') + " module,please install base modules and try again");
        return false;
    }
    return true;
}; };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uip-alpha/shared-utils/dist/module/index.js
// module id = ZUlu
// module chunks = 1